export default class ContactInfo {
  constructor(data) {
    this.email = data.Email || data.email;
    this.firstName = data.FirstName || data.firstName;
    this.lastName = data.LastName || data.lastName;
    this.phoneNumber = data.PhoneNumber || data.phoneNumber;
    this.company = data.Company || data.company;
    this.country = data.country;
    this.state = data.state;
    this.suburb = data.suburb;
    this.postcode = data.postcode;
    this.streetAddress = data.streetAddress;
    this.streetAddressLineTwo = data.streetAddressLineTwo;
  }

  update(data) {
    Object.keys(data).forEach((key) => {
      this[key] = data[key];
    });
  }

  getAddressPayload() {
    return {
      Country: this.country,
      State: this.state,
      Suburb: this.suburb,
      PostCode: this.postcode,
      StreetAddress: this.streetAddress,
      StreetAddressLineTwo: this.streetAddressLineTwo,
    };
  }
}
